import { Api } from 'utils';

class BillPlanService {
	
	static admin = {
		get: async (params?: any) => Api.createResponse('admin/bill-plans',params),
		save: async (params?: any) => Api.createResponse('admin/bill-plans/save',params),
		saveUser: async (params?: any) => Api.createResponse('admin/bill-plans/save-user',params),
		delete: async (params?: any) => Api.createResponse('admin/bill-plans/delete',params),
		getPlanList: async (params?: any) => Api.createResponse('admin/bill-plans/plan-list',params),
		deletePlanUser: async (params?: any) => Api.createResponse('admin/bill-plans/delete-plan-user',params),
	}

}

export default BillPlanService;